// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"49c6f738","431":"80080fba","810":"c94d2b0f"}[chunkId] + ".chunk.css";
};